import Model, { attr, belongsTo } from '@ember-data/model';

export default class Kyc extends Model {
  @attr provider; // Name of the KYC provider. Possible values: "onfido", "fourthline"
  @attr providerStatus; // Fourthline session statuses. Possible values: "process_finished", "kyc_required", "qes_required", "error"
  @attr redirectUrl; // Redirect URL from Fourthline
  @attr isQesRequired;
  @attr reason; // A more precise reason if provider_status is equal to "failed" or "canceled"

  @belongsTo('stakeholder', { async: true, inverse: null }) stakeholder; // Stakeholder refers to membership on register.membership.id
}
